import React from 'react';
import { SpaceBetween } from '@amzn/awsui-components-react-v3';
import { CartAccessItem, TemplateMetadata } from 'src/components/common/checkout/common';
import { DataConsumerType, MatchedTemplateWorkflow } from 'aws-sdk/clients/awsdatalakegladstonelambda';
import UseCaseComponent from 'src/components/permissions/myPermissions/useCase/useCaseComponent';
import { DataConsumerTypeSelector } from 'src/components/common/checkout/dataConsumerTypeSelector';

export interface AdditionalDetailsEditorProps {
  cartItems: CartAccessItem[];
  activeGroup: string;
  activeWorkspace: any;
  // unique templates that matched.
  additionalMetadata: TemplateMetadata[];
  setAdditionalMetadata: (additionalMetadata: TemplateMetadata[]) => void;
  // all templates that matched, might have duplicate templateIds
  matchedTemplates: MatchedTemplateWorkflow[];
  username: string;
  useCase: string;
  setUseCase: (value: string) => void;
  dataConsumerType: DataConsumerType;
  setDataConsumerType: (value: DataConsumerType) => void;
  formSubmitted: boolean;
}

export const AdditionalDetailsEditor = (props: AdditionalDetailsEditorProps) => {
  return (
    <SpaceBetween size={'l'} direction={'vertical'}>
      <UseCaseComponent value={props.useCase} formSubmitted={props.formSubmitted} onChange={props.setUseCase} />
      <DataConsumerTypeSelector
        dataConsumerType={props.dataConsumerType}
        setDataConsumerType={props.setDataConsumerType}
      />
    </SpaceBetween>
  );
};
